import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import { MODAL_ADMIN_EDIT_PAYMENT } from 'redux/modules/modals'

const defaultColumnData = [
  { id: 'payment_type', numeric: false, disablePadding: false, label: 'Nom' },
  { id: 'currency', numeric: false, disablePadding: false, label: 'Devise' }
]
export default class AdminPaymentsComponent extends Component {
  static propTypes = {
    payments: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired,
    refreshPayments: PropTypes.func.isRequired
  }
  state = {
    columnData: []
  }
  handleEditPricingClick = taxe => {
    this.props.showModal(MODAL_ADMIN_EDIT_PAYMENT)
  }

  handleReorderClick = () => {}

  componentDidMount() {
    if (this.props.payments.length === 0) {
      this.props.refreshPayments()
    }
  }
  componentWillMount() {
    this.setState({ columnData: defaultColumnData })
  }
  render() {
    const { payments } = this.props
    const { columnData } = this.state
    return (
      <AdminTableComponent
        title="Modes de paiement"
        search={['payment_type']}
        readOnly
        list={payments}
        orderBy={'payment_type'}
        columnData={columnData}
        editButtonAction={this.handleEditPricingClick}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Settings/components/payments/AdminPaymentsComponent.js